import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, mergeMap, Observable } from 'rxjs';
import { API_BASE_URL } from '../../../app.definitions';
import { BaseAppState } from '../../../core/store/reducers';
import { AuthSelectors } from '../selectors/auth.selectors';

const REQUEST_HEADER_AUTHORIZATION = 'Authorization';

@Injectable()
export class CustomHeaderInjectorInterceptor implements HttpInterceptor {
  private readonly accountRoutesWithAuthorization = [
    'confirm-tos',
    'confirm',
    'signout',
    'approve',
  ];

  constructor(
    @Inject(API_BASE_URL) private readonly apiBaseUrl: string,
    private readonly store: Store<BaseAppState>
  ) {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.shouldAddAuthorizationHeader(request)) {
      return this.store.select(AuthSelectors.getToken).pipe(
        first(),
        mergeMap((token) => {
          if (token) {
            const authReq = request.clone({
              setHeaders: {
                [REQUEST_HEADER_AUTHORIZATION]: `Bearer ${token}`,
              },
            });
            return next.handle(authReq);
          }
          return next.handle(request);
        })
      );
    } else {
      return next.handle(request);
    }
  }

  private shouldAddAuthorizationHeader(request: HttpRequest<unknown>): boolean {
    if (!request.url) {
      return false;
    }

    if (request.url.startsWith(`${this.apiBaseUrl}/account`)) {
      if (this.accountRoutesWithAuthorization.some((x) => request.url.endsWith(x))) {
        return true;
      }
      return false;
    }

    if (request.url.startsWith('./assets')) {
      return false;
    }

    return true;
  }
}
